export const POPUP = "popup_form"
export const PROFILE = "profile_form"
export const USERS_FILTER = "users_filter_form"
export const CREATE_USER = "create_user_form"
export const MULTIPLE_USER = "multiple_user_form"
export const ONBOARDING_FLOW_WIZARD = "onboarding_flow_wizard_form"
export const DOMAINS_RESTRICT_REGISTRATION = "restrict_registration_form"
export const DOMAIN = "domain_form"
export const BUSINESS_UNIT = "business_unit_form"
export const PROFILE_TAGS = "profile_tags_form"
export const EXPERIENCE = "experience_form"
export const BASIC_CONTENT_FEATURE = "basic_content_feature_form"
export const CREATE_BOOKING_FEATURE = "create_booking_feature_form"
export const COUNTDOWN_CLOCK_FEATURE = "countdown_clock_feature_form"
export const DOCUMENT_FEATURE = "document_feature_form"
export const DOCUMENT_LIST = "document_list_form"
export const EVENT_INFO = "event_info_form"
export const FORM_BUILDER = "form_builder_form"
export const LEADERBOARD = "leaderboard_form"
export const LIST = "list_form"
export const MEDIA_GALLERY = "media_gallery_form"
export const PLACES = "places_form"
export const POLL = "poll_form"
export const PRIVATE_MESSAGE = "private_message_form"
export const REFER_FRIEND = "refer_friend_form"
export const QUESTIONNAIRE = "questionnaire_form"
export const SURVEY = "survey_form"
export const TRIVIA_CHALLENGE = "trivia_challenge_form"
export const CALENDAR_EVENTS = "calendar_events_form"
export const WEB_LINK = "web_link_form"
export const COMMENT_BOARD = "comment_board_form"
export const NOTIFICATION = "notification_form"
export const CUSTOM_EMAIL = "custom_email_form"
export const WEB_ALERT = "web_alert_form"
export const CLIENT = "client_form"
export const VENDOR_FEATURES = "vendor_features_form"
export const LANDING_SCREEN = "landing_screen_form"
export const LIST_SCREEN = "list_screen_form"
export const CONTACT_US = "contact_us_form"
export const PLATFORM_SETTINGS = "platform_settings_form"
export const EMAIL_MESSAGES_SETUP = "email_messages_setup_form"
export const EDIT_CONTACT = "edit_contact_form"
export const CHANGE_PASSWORD = "change_password_form"
export const PLACES_FEATURE = "places_feature_form"
export const CREATE_CATEGORY = "create_category_form"
export const EXPERIENCES_FILTER = "experiences_filter_form"
export const CREATE_BOOKING = "create_booking_form"
export const CALENDAR_GROUP = "calendar_group_form"
export const SUB_CALENDARS = "sub_calendars_form"
export const EVENT_CALENDAR = "event_calendar_form"
export const CALENDAR_EVENT = "calendar_event_form"
export const ORDERS_FILTER = "orders_filter_form"
export const PRODUCT = "product_form"
export const PRODUCT_CATEGORIES = "product_categories_form"
export const ADMIN_ROLE = "admin_role_form"
export const PERMISSIONS = "permissions_form"
export const PAYOUTS = "payouts_form"
export const CODES_FILTER = "codes_filter_form"
export const GENERATE_CODE = "generate_code_form"
export const ADD_USER = "add_user_form"
export const VIDEO_CALL = "video_call_form"
export const IFO_ORDER_FORM = "ifo_order_form"
export const HARVARD_ORDER_FORM = "harvard_order_form"
export const TAG_FORM = "tag_form"
export const LOGIN_FORM = "login_form"
export const RESET_PWD_FORM = "reset_pwd_form"
export const DEFAULT_ORDER = "default_order_form"
export const DM_ACCESS_CONTROLS = "dm_access_controls"
